<template>
    <div
        class="btn outline-none text-base focus:outline-none active:outline-none text-center items-center justify-center lg:cursor-pointer px-3 py-2"
        :class="btnClassComputed"
        v-bind="$attrs"
    >
        <slot></slot>
    </div>
</template>
<script>
import PropsHelper from "@/helper/PropsHelper"
export default {
    name: "VBtn",
    props: {
        large: {
            type: Boolean
        },
        blocked: {
            type: Boolean
        },
        variant: {
            type: String
        }
    },
    computed: {
        variantComputed: function () {
            return PropsHelper.getStringProp(this.variant)
        },
        btnClassComputed: function () {
            let clsObj = { 'btn-lg': this.large, 'btn-blocked': this.blocked }
            if (this.variantComputed != null) {
                clsObj["btn-" + this.variantComputed] = true
            }
            return clsObj
        }
    }
}
</script>

<style lang="scss" scoped>
.btn {
    height: 36px;
    width: auto;
    outline: none !important;
    display: inline-flex;
    background-color: transparent;

    &:active {
        outline: none !important;
        background-color: transparent;
    }

    &.btn-blocked {
        display: flex;
        width: 100%;
    }

    &.btn-lg {
        height: 55px;
    }

    &.btn-primary {
        // background-image: url("../../assets/button/btn-primary.svg");
        // background-repeat: no-repeat;
        // background-size: 100% 100%;
        background: linear-gradient(90deg, #1C2C73 0%, #016CB8 100%);
        border-radius: 50px 0px 50px 0px;
        color: white;
    }
    &.btn-disable {
        background-color: #BBBBBB;
        border-radius: 50px 0px 50px 0px;
        // background-image: url("../../assets/button/btn-disabled.svg");
        // background-repeat: no-repeat;
        // background-size: 100% 100%;
        color: #858585;
    }

    &.btn-outline {
        border-radius: 50px 0px;
        border: 1px solid #17377F;
        background: #FFF;
        color: #17377F;
    }
}
</style>
